import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook to handle GM user redirect for EscalatedQueries page
 * @param {Object} user - Current user from auth context
 * @param {boolean} authLoading - Auth loading state
 */
export const useEscalatedQueriesAuth = (user, authLoading) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && user) {
      const roleNormalized = (user?.role || '').toString().trim().toLowerCase();
      if (roleNormalized === 'gm') {
        navigate('/dashboard/queries/assigned', { replace: true });
      }
    }
  }, [authLoading, user, navigate]);
};
